const TokenKey = 'X-AUTH-TOKEN-KEY'

export function getToken () {
  return sessionStorage.getItem(TokenKey)
}

export function setToken (token) {
  sessionStorage.setItem(TokenKey, token)
}

export function removeToken () {
  sessionStorage.removeItem(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js